import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiMail, FiKey, FiArrowRight } = FiIcons;

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success('Welcome back, Admin');
      navigate('/admin');
    } catch (err) {
      toast.error(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white p-10 rounded-[3rem] border border-[#e5e0d5] shadow-xl">
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-[#f4f1ea] rounded-[1.5rem] flex items-center justify-center mx-auto mb-6 shadow-inner">
            <SafeIcon icon={FiLock} className="w-8 h-8 text-[#8c7851]" />
          </div>
          <h1 className="text-3xl font-serif font-bold text-[#2c2c2c]">Parents Admin</h1>
          <p className="text-sm text-[#6b6b6b] mt-2">Manage the family memory book</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8c7851] ml-1">Admin Email</label>
            <div className="relative group">
              <SafeIcon icon={FiMail} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-300 group-focus-within:text-[#8c7851] transition-colors w-4 h-4" />
              <input 
                type="email" 
                placeholder="your.email@example.com" 
                className="w-full pl-11 pr-6 py-4 rounded-2xl border-2 border-stone-100 focus:border-[#8c7851] outline-none transition-all font-medium"
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8c7851] ml-1">Password</label>
            <div className="relative group">
              <SafeIcon icon={FiKey} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-300 group-focus-within:text-[#8c7851] transition-colors w-4 h-4" />
              <input 
                type="password" 
                placeholder="••••••••" 
                className="w-full pl-11 pr-6 py-4 rounded-2xl border-2 border-stone-100 focus:border-[#8c7851] outline-none transition-all font-medium"
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
            </div>
          </div>

          <button 
            type="submit" 
            disabled={loading} 
            className="w-full bg-[#2c2c2c] text-white py-5 mt-4 rounded-2xl font-bold flex items-center justify-center gap-3 hover:bg-black transition-all active:scale-[0.98] disabled:opacity-50 shadow-lg shadow-stone-200"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                <span className="text-lg">Sign In to Dashboard</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;